// ─── appVersion.js ────────────────────────────────────────────────────────────
// Build identity, derived from the actual build — NOT hand-maintained.
//
// Everything below comes from REACT_APP_* vars that scripts/build-with-info.js
// stamps in at build time (semver from package.json, timestamp from the clock,
// commit from Vercel or local git). Editing this file cannot change what a
// deployed build reports; to change the version number, bump `version` in
// package.json.
//
// Dev-server builds (`npm start`) get no stamp and fall back to the 'dev'
// markers below, which is the honest answer — a dev bundle has no release
// identity.

const env = process.env;

export const APP_VERSION = env.REACT_APP_VERSION || 'dev';
export const BUILD_TIME = env.REACT_APP_BUILD_TIME || '';
export const GIT_SHA = env.REACT_APP_GIT_SHA || '';
export const GIT_DIRTY = env.REACT_APP_GIT_DIRTY === '1';
export const DEPLOY_ENV = env.REACT_APP_DEPLOY_ENV || 'local';

// Seven hex chars is what `git log --oneline` shows and what a reader can paste
// straight back into `git show` — enough to identify a commit in this repo.
export const GIT_SHA_SHORT = GIT_SHA.slice(0, 7);

// "25 Sep 2026, 06:41 UTC" — unambiguous across the dd/mm vs mm/dd divide, and
// explicitly UTC so a build stamped late in the Australian evening doesn't read
// as the previous day without explanation. Returns '' for a missing or
// unparseable stamp so callers can hide the line rather than print 'Invalid Date'.
export function formatBuildTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}, `
    + `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} UTC`;
}

// The one line the version panel shows under the version number. Built here
// rather than in the component so the assembly is unit-testable and the same
// string can be reused (e.g. in a bug report) without duplicating the rules.
// Omits whatever isn't known instead of printing empty separators.
export function buildStamp() {
  const parts = [];
  const when = formatBuildTime(BUILD_TIME);
  if (when) parts.push(when);
  if (GIT_SHA_SHORT) parts.push(GIT_SHA_SHORT + (GIT_DIRTY ? '-dirty' : ''));
  if (DEPLOY_ENV && DEPLOY_ENV !== 'production') parts.push(DEPLOY_ENV);
  return parts.join(' · ');
}

// Cache key for the service worker. Ties the SW's cache name and its script URL
// to the exact build, so a deploy always looks like a new worker to the browser
// and the previous build's cache is dropped on activate. Falls back to the
// version alone when there is no sha to pin to.
export const BUILD_ID = GIT_SHA_SHORT ? `${APP_VERSION}-${GIT_SHA_SHORT}` : APP_VERSION;
